import { useCallback } from "react";

import Helmet from "react-helmet";

import { datadogRum } from "@datadog/browser-rum";

import LoginForm, {
  type LoginFormData,
} from "@covertree/ui/forms/auth/LoginForm";

import { useAuthContext } from "@covertree/auth";
import { Toast } from "@covertree/utils";

interface LoginProps {
  forgotPasswordPath?: string;
  isPasswordless: boolean;
  title: string;
}

const Login = ({ forgotPasswordPath, isPasswordless, title }: LoginProps) => {
  const { login } = useAuthContext();

  const submit = useCallback(
    async (form: LoginFormData) => {
      try {
        await login(
          isPasswordless
            ? { username: `+1${form.username}` }
            : { username: form.username, password: form.password }
        );
      } catch (e) {
        datadogRum.addError(e);
        Toast.showError("Cannot log in. Please try again or contact CoverTree");
      }
    },
    [login]
  );

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <LoginForm
        forgotPasswordPath={forgotPasswordPath}
        usernameType={isPasswordless ? "phone" : "email"}
        submit={submit}
      />
    </>
  );
};

export default Login;
